import { Box3, BufferGeometry, Group, Line } from "three";
import { Jaco } from "oc-jaco3d/arrangement/Jaco";
import { Empty } from "../arrangement/Empty";
import { AbstractPart3d } from "./AbstractPart3d";
import { createUnitBoxMesh } from "../commons/Utils";
import { v3 } from "oc-threejs/short3";
import * as Scenes from "oc-threejs/Scenes";

export class Empty3d extends AbstractPart3d {
  CLASS_NAME = "Empty3d";
  declare jaco: Empty;

  emptySpaceVisualizerBox = null;
  festerAbstandVisualisierung = null;

  constructor(jaco: Jaco) {
    super(jaco);
    if (!APP.isTorkonfigurator) {
      this.initEmptySpaceVisualizer();
    }
  }

  initEmptySpaceVisualizer() {
    const material = APP.materials.create("materialShowEmptySpaces");
    this.emptySpaceVisualizerBox = createUnitBoxMesh(material, "emptySpaceVisualizerBox");
    this.add(this.emptySpaceVisualizerBox);
  }

  update3d() {
    super.update3d();
    const box = this.getBox();
    this.visible = APP.arrangement.zauneditorReady;
    if (!APP.isTorkonfigurator) {
      this.updateEmptySpaceVisualizer(box);
    }

    if (this.changed("automatischeBreite") || this.changed("breite")) {
      Scenes.remove(this.festerAbstandVisualisierung);
      this.festerAbstandVisualisierung = null;
      if (!(this.jaco as Empty).automatischeBreite) {
        this.festerAbstandVisualisierung = new Group();
        this.add(this.festerAbstandVisualisierung);

        const line = (v1, v2, dashed) => {
          const material = APP.materials.create(
            dashed ? "fixAbstandLineDashedMaterial" : "fixAbstandLineMaterial"
          );
          const line = new Line(new BufferGeometry().setFromPoints([v1, v2]), material);
          line.computeLineDistances();
          this.festerAbstandVisualisierung.add(line);
        };

        const x = (this.jaco as Empty).breite;
        const y = 0.01;
        const z = 0.1;
        // Mittellinie
        line(v3(0, y, 0), v3(x, y, 0), true);
        // Endstücke
        line(v3(0, y, -z), v3(0, y, +z), false);
        line(v3(x, y, -z), v3(x, y, +z), false);
      }
    }
  }

  updateEmptySpaceVisualizer(box: Box3) {
    const scale = box.getSize(v3());
    const position = box.getCenter(v3());
    this.emptySpaceVisualizerBox.scale.copy(scale);
    this.emptySpaceVisualizerBox.position.copy(position);
  }

  clone(recursive?: boolean) {
    return new Empty3d(this.jaco) as this;
  }
}
